import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import Sidebar, { SidebarMenuItem } from "../components/Sidebar";
import OperationView from "./battery/OperationView";
import DrivingManagementView from "./driving/DrivingManagementView";
import { Vehicle } from "../data/database";

interface ControlLayoutProps {
    vehicles: Vehicle[];
}

const controlMenuItems: SidebarMenuItem[] = [
    {
        id: "battery",
        label: "배터리 관제",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="7" width="16" height="10" rx="2" ry="2"></rect>
                <line x1="22" y1="11" x2="22" y2="13"></line>
            </svg>
        ),
    },
];

export default function ControlLayout({ vehicles }: ControlLayoutProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("battery");

    // Sync activeTab with URL path
    const pathParts = location.pathname.split("/");
    const currentTab = pathParts[pathParts.length - 1];
    
    useEffect(() => {
        if (controlMenuItems.some(item => item.id === currentTab)) {
            setActiveTab(currentTab);
        } else {
            setActiveTab("battery");
        }
    }, [location, currentTab]);

    const handleMenuSelect = (id: string) => {
        setActiveTab(id);
        navigate(`/control/${id}`);
    };

    return (
        <div style={{ display: 'flex', width: '100%', height: '100%' }}>
            <Sidebar
                title="관제"
                titleIcon={
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                    </svg>
                }
                menuItems={controlMenuItems}
                activeItem={activeTab}
                onSelect={handleMenuSelect}
            />

            <div style={{ flex: 1, height: '100%', minWidth: 0, display: 'flex', flexDirection: 'column' }}>
                <Routes>
                    <Route path="battery" element={<OperationView vehicles={vehicles} />} />

                    <Route path="*" element={<Navigate to="battery" replace />} />
                </Routes>
            </div>
        </div>
    );
}
